import {
  intersectionWatcher,
  delayOffset,
  shouldAnimate,
} from "@/lib/animation";

const selectors = {
  items: `
    .contact__image > .image, .contact__image > .placeholder-svg,
    .contact__heading,
    .contact__text,
    .contact__form > *,
    .animation--section-introduction > *,
    .about__block,
    .page__content
  `,
};

export default node => {
  if (!shouldAnimate(node)) return;

  // Add the animation delay offset variables
  delayOffset(node, [selectors.items]);

  const observer = intersectionWatcher(node);

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
